<template>
    <main>
        <header class="tw-w-full tw-bg-white">
          <div class="tw-container tw-h-full tw-flex tw-items-center tw-justify-center lg:tw-justify-between">
            <img src="~@/assets/img/logo-new.svg">
            <p class="tw-hidden tw-text-right lg:tw-block"><span>Ebook Gratuito </span>- “Aprenda a Investir em Bolsa”</p>
          </div>
        </header>
        <section class="hero">
            <div class="lg:tw-container tw-flex tw-flex-col lg:tw-flex-row lg:tw-justify-between lg:tw-gap-5">
                <div class="info lg:tw-pt-12">
                    <img src="~@/assets/img/icons/book.svg" class="tw-hidden lg:tw-block lg:tw-pb-6">
                    <p class="tw-text-center lg:tw-text-left tw-text-white lg:tw-pb-6">Ebook Gratuito<br><span><i>“Aprenda a Investir em bolsa”</i></span></p>
                    <h1 class="tw-hidden lg:tw-block lg:tw-text-left tw-text-white lg:tw-px-0 lg:tw-pb-6">Registe-se e <b>receba gratuitamente</b> um <b>Ebook</b>!<br><span>Aprenda a investir de forma rápida e simples na bolsa:</span></h1>
                    <ul class="tw-hidden lg:tw-block">
                        <li class="tw-text-left tw-text-white tw-relative tw-font-light tw-mb-2 tw-text-lg">Ebook informativo/educacional</li>
                        <li class="tw-text-left tw-text-white tw-relative tw-font-light tw-mb-2 tw-text-lg">Parte teórica e prática.</li>
                    </ul>
                </div>
                <div class="form-container tw-mt-3 lg:tw-mt-0 tw-relative">
                    <Form v-if="!$store.state.formSuccess" />
                    <FormSuccess v-if="$store.state.formSuccess" />
                </div>
            </div>
        </section>

        <section class="strategies">
            <div class="tw-container tw-py-5">
                <h1 class="tw-text-center tw-pb-6">Ebook - <i>“Aprenda a Investir em bolsa”</i></h1>
                <p class="tw-text-center tw-pb-8">Investir na bolsa pode ser uma tarefa assustadora. <b>Onde começar? Que ações comprar? Quanto investir?</b> Há muitas perguntas a serem feitas e respondidas. É por isso que criamos o Ebook <i>“Aprenda a Investir em Bolsa”</i>. Este Ebook é ideal para os traders mais experientes e para investidores principiantes.</p>
                <p class="tw-text-center tw-pb-5 lg:tw-pb-auto"><b>Neste Ebook, disponibilizamos informações vitais para ajudá-lo na sua própria descoberta dos mercados financeiros:</b></p>

                <div class="tw-grid tw-grid-cols-1 lg:tw-grid-cols-2 lg:tw-gap-5 lg:tw-py-5">
                    <div class="tw-flex tw-flex-col tw-items-center tw-justify-center tw-text-center lg:tw-flex-row lg:tw-justify-start">
                        <img src="~@/assets/img/icons/grid-1.svg">
                        <p>Obtenha uma <b>visão clara e concisa</b> do <b>mercado de ações</b></p>
                    </div>
                    <div class="tw-flex tw-flex-col tw-items-center tw-justify-center tw-text-center lg:tw-flex-row lg:tw-justify-start">
                        <img src="~@/assets/img/icons/grid-2.svg">
                        <p>Aprenda como <b>potenciar os seus investimentos</b> no maior mercado do mundo</p>
                    </div>
                    <div class="tw-flex tw-flex-col tw-items-center tw-justify-center tw-text-center lg:tw-flex-row lg:tw-justify-start">
                        <img src="~@/assets/img/icons/grid-3.svg">
                        <p>Descubra as <b>informações chave</b> necessárias para começar a <b>investir na bolsa</b></p>
                    </div>
                    <div class="tw-flex tw-flex-col tw-items-center tw-justify-center tw-text-center lg:tw-flex-row lg:tw-justify-start">
                        <img src="~@/assets/img/icons/grid-4.svg">
                        <p>Aprenda passo a <b>passo como investir/negociar</b> com <b>exemplos práticos</b></p>
                    </div>
                </div>
            </div>
        </section>

        <section class="free-ebook">
            <div class="tw-container tw-flex tw-flex-col tw-items-center tw-justify-center lg:tw-flex-row lg:tw-justify-between">
                <div><h1 class="tw-text-white tw-uppercase tw-text-center lg:tw-text-left tw-pb-4 lg:tw-pb-0">REGISTE-SE JÁ E RECEBA O SEU EBOOK GRÁTIS</h1></div>
                <div class="tw-flex tw-items-center tw-justify-center lg:tw-justify-end"><button v-scroll-to="'.hero'" class="btn-page tw-w-full lg:tw-w-auto tw-outline-none tw-text-white tw-text-center tw-uppercase">SAIBA MAIS <span style="-webkit-transform: rotate(-90deg);">❯</span></button></div>
            </div>
        </section>
        <section class="caution tw-py-10 lg:tw-py-20">
            <div class="tw-container lg:tw-px-32 tw-flex tw-flex-col-reverse tw-justify-center tw-items-center lg:tw-flex-row-reverse lg:tw-justify-between">
                <div class="tw-pb-8 lg:tw-pb-0 tw-w-full">
                    <img src="~@/assets/img/alert.png">
                </div>
                <div class="lg:tw-px-12 tw-flex tw-flex-col tw-items-start tw-justify-center">
                    <h3 class="tw-uppercase tw-text-center lg:tw-text-left tw-pb-2">ADVERTÊNCIAS ESPECÍFICAS AO INVESTIDOR</h3>
                    <p class="tw-text-center lg:tw-text-left tw-pb-4">O indicador de risco resumido é uma guia do nível de risco deste produto comparado com outros produtos. Apresenta a probabilidade do produto perder dinheiro por causa dos movimentos nos mercados ou porque não temos capacidade para lhe pagar.</p>
                    <p class="tw-text-center lg:tw-text-left tw-pb-4">Este produto está classificado como 7 de 7, o que se traduz como a classe de risco mais elevada. Tal avalia as perdas potenciais de desempenho futuro a um nível extremamente elevado.</p>
                    <p class="tw-text-center lg:tw-text-left tw-pb-4">Os CFDs são produtos alanvancados que, dados os movimentos dos mercados subjacentes, podem produzir perdas muito rapidamente. Não existe proteção de capital contra risco de mercado, risco de crédito ou risco de liquidez.</p>
                    <p class="tw-text-center lg:tw-text-left tw-pb-4">Entre 59.64% e 71% das contas de investidores de retalho perdem dinheiro quando negoceiam CFD com estes fornecedores. Deve considerar se compreende como funcionam os CFDs e se pode correr o elevado risco de perda do seu dinheiro.</p>
                </div>
            </div>
        </section>
        <footer v-scroll-to="'form'">
          <div>
            <div class="tw-container tw-flex tw-justify-center tw-items-center">
              <small class="tw-text-white tw-text-center tw-block">O Banco Invest S.A., é uma instituição registada no Banco de Portugal com o código 0014 e na Comissão de Mercado e Valores Mobiliários sob o n° 0141.</small>
            </div>
          </div>
          <div>
            <div class="tw-container">
              <div class="tw-flex tw-flex-col tw-justify-center tw-items-center lg:tw-gap-5 lg:tw-flex-row">
                <small class="tw-text-white tw-block">© {{new Date().getFullYear()}} BANCO INVEST - TODOS OS DIREITOS RESERVADOS</small>
                <img src="~@/assets/img/footer.png" class="tw-block">
              </div>
            </div>
          </div>
        </footer>
    </main>
</template>
<script>
import Form from '@/components/FormB.vue';
import FormSuccess from '@/components/FormSuccessB.vue';

export default {
    name: 'HomeB',
    components: {
        Form,
        FormSuccess,
    },
};
</script>
